import React, {useState, useMemo, useCallback} from 'react';
import {useRoute} from '@react-navigation/native';
import {
  Keyboard,
  Linking,
  Platform,

  KeyboardAvoidingView,
  ScrollView,
} from 'react-native';
import {Button} from '../../../components/Interface/Forms/Buttons/Button';
import {Header} from '../../../components/Interface/Headers/Header';
import {Titles} from '../../../components/Interface/Typographies/Titles';
import {Picker} from '../../../components/Interface/Forms/Inputs/Picker';
import {Loading} from '../../../components/Interface/Loadings/Loading';

import {
  Container,
  Content,
  InputGroup,
  Form,

  Footer,
  LinkButtonContainer,
  LinkButton,
  LinkButtonText,
  InputRow,
} from './styles';

import {Input} from '../../../components/Interface/Forms/Inputs/Input';
import {useCards} from '../../../context/cards';
import {estados} from '../../../utils/estados';
import useCep from '../../../context/cep';
import {api} from '../../../services/api';
import {RootStackParamList} from '../../../dtos/RoutesDTO';
import CardPreview from '../../../components/shared/CardPreview';
import {SafeAreaView} from 'react-native-safe-area-context';
import {RFValue} from 'react-native-responsive-fontsize';

export function EditCreditCardAddress() {
  const {fetchUserCreditCardList} =
    useCards();

  const route = useRoute();

  const {action, selectedCard} = route.params as RootStackParamList['EditCreditCardAddress'];

  const {buscaCep} = useCep();

  const [nome, setNome] = useState('');
  const [cep, setCep] = useState('');
  const [endereco, setEndereco] = useState('');
  const [complemento, setComplemento] = useState('');
  const [numero, setNumero] = useState('');
  const [cidade, setCidade] = useState('');
  const [estado, setEstado] = useState('select');

  const [isLoading, setIsLoading] = useState(false);

  const formEnderecoHabilitado = useMemo(
    () =>
      cep.length === 8 &&
      endereco.length > 4 &&
      cidade.length > 4 &&
      !!estado &&
      !!numero,
    [cep, endereco, cidade, estado, numero],
  );

  const handleChangeCep = async (_: string, extracted = '') => {
    setCep(extracted);
    if (extracted.length === 8) {
      try {
        const {data} = await buscaCep(extracted);
        if (data?.erro) {return;}
        setCidade(data.bairro);
        setComplemento(data.complemento);
        setEndereco(data.logradouro);
        setEstado(data.uf);
      } catch (error) {}
    }
  };

  const addCardAddress = useCallback(async () => {
    setIsLoading(true);
    try {
      await api.post('/completaEndereco', {
        endereco,
        numero,
        cidade,
        estado,
        complemento,
        cep,
        pais: 'BR',
        cardId: selectedCard.id,
        nome,
      });

      fetchUserCreditCardList({});

      action();
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }, [
    endereco,
    numero,
    cidade,
    estado,
    complemento,
    cep,
    selectedCard,
    nome,
    action,
    fetchUserCreditCardList,
  ]);

  return (
    <SafeAreaView edges={['bottom']} style={{flex: 1}}>
      {isLoading && <Loading />}
      <Header icon="chevron-left" />

      <KeyboardAvoidingView
        style={{flex: 1}}
        behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
       >
        <ScrollView
          showsVerticalScrollIndicator={false}
          keyboardShouldPersistTaps="handled"
          contentContainerStyle={{
            paddingBottom:  RFValue(20),
          }}
          bounces={false}>
          <Container>


            <Content>
              <Titles
                title="Dados do cartão"
                subtitle="Digite o titular e endereço da fatura:"
              />

              <CardPreview card={selectedCard} />

              <Form>
                <InputGroup>
                  <Input
                    labelText="Nome do titular"
                    value={nome}
                    onChangeText={setNome}
                    returnKeyType="next"
                  />
                </InputGroup>

                <InputRow>
                  <InputGroup style={{flex: 1}}>
                    <Input
                      labelText="Cep"
                      mask="[00000]-[000]"
                      value={cep}
                      onChangeText={(_, extracted) =>
                        handleChangeCep(_, extracted)
                      }
                      returnKeyType="next"
                    />

                  </InputGroup>
                       <InputGroup style={{flex: 1}}>
                      <Picker
                        label={'Estado'}
                        value={estado}
                        placeholder={{
                          label: 'Selecionar',
                          value: 'select',
                        }}
                        onChangeValue={setEstado}
                        items={estados}
                      />
                    </InputGroup>
                </InputRow>
                <InputGroup style={{flex: 1}}>
                  <Input
                    labelText="Endereço"
                    value={endereco}
                    onChangeText={setEndereco}
                    returnKeyType="next"
                  />
                </InputGroup>
                <InputRow>
                  <InputGroup style={{flex: 1}}>
                    <Input
                      labelText="Número"
                      value={numero}
                      keyboardType="number-pad"
                      onChangeText={setNumero}
                      maxLength={9}
                      returnKeyType="next"
                    />
                  </InputGroup>
                  <InputGroup style={{flex: 1}}>
                    <Input
                      labelText="Complemento"
                      value={complemento}
                      onChangeText={setComplemento}
                      returnKeyType="next"
                    />
                  </InputGroup>
                </InputRow>

                <InputRow>
                  <InputGroup style={{flex: 1}}>
                    <Input
                      labelText="Cidade"
                      value={cidade}
                      onChangeText={setCidade}
                      returnKeyType="done"
                      onSubmitEditing={() => Keyboard.dismiss()}
                    />
                  </InputGroup>
                </InputRow>

                  <LinkButtonContainer>
            <LinkButton
              activeOpacity={1}
              onPress={() =>
                Linking.openURL(
                  'https://barataocombustiveis.com.br/termos-e-condicoes',
                )
              }>
              <LinkButtonText>
                Termos de uso do{' '}
                {selectedCard.voucher ? 'vale' : 'cartão de crédito'}
              </LinkButtonText>
            </LinkButton>
          </LinkButtonContainer>

              </Form>
            </Content>


          <Footer>
            <Button
              title={'Continuar'}
              onPress={() => addCardAddress()}
              enabled={formEnderecoHabilitado}
            />
          </Footer>
          </Container>


        </ScrollView>
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
}
